import api, { withLoading } from '@/api/api';
import { BeneficiosEnum } from '@/core/enums/beneficios';

const resource = `v1/formpd`;
const LOADING_KEY = 'formpd-justificativas';

export default {
    /**
     * Busca justificativas de dispêndios para o FormP&D (sempre LB).
     * @param {number} empresaId
     * @param {string} tipo - 'colaboradores' | 'servicos-terceiros' | 'materiais-lb'
     * @param {object} params - { competenciaIni, competenciaFim }
     */
    getJustificativas(empresaId, tipo, params = {}) {
        const { competenciaIni, competenciaFim } = params;
        const query = `competenciaIni=${competenciaIni}&competenciaFim=${competenciaFim}&trabalho=${BeneficiosEnum.LEI_DO_BEM}`;
        return withLoading(LOADING_KEY, () =>
            api.get(`${resource}/${empresaId}/justificativas/${tipo}?${query}`).then(res => res.data)
        );
    },

    /**
     * Cria uma nova justificativa de dispêndio.
     * @param {number} empresaId
     * @param {object} data
     */
    createJustificativa(empresaId, data) {
        return withLoading(LOADING_KEY, () =>
            api.post(`${resource}/${empresaId}/justificativas`, data).then(res => res.data)
        );
    },

    /**
     * Atualiza uma justificativa de dispêndio existente.
     * @param {number} empresaId
     * @param {number} justificativaId
     * @param {object} data
     */
    updateJustificativa(empresaId, justificativaId, data) {
        return withLoading(LOADING_KEY, () =>
            api.post(`${resource}/${empresaId}/justificativas/${justificativaId}`, data).then(res => res.data)
        );
    },

    /**
     * Importação de justificativas em lote.
     * @param {number} empresaId
     * @param {FormData} data
     */
    importJustificativas(empresaId, data) {
        return withLoading(LOADING_KEY, () =>
            api.post(`${resource}/${empresaId}/justificativas/importar`, data).then(res => res.data)
        );
    },
}
